
import { map, toArray, empty, singleton, ofArray, append } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { toList, containsKey, tryFind, ofList } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { comparePrimitives } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";

export const addWavesItem = "Add waveforms to viewer";

export const addWireWaveItem = "Add wave to viewer";

export const viewLibraryItem = "View library component";

export const hideLibraryItem = "Hide library component";

function sheetItems(offerSetAsTop) {
    return append(ofArray(["Rename", "Duplicate", "Delete"]), append(offerSetAsTop ? singleton("Set as top") : empty(), ofArray(["Save as library component", "Write design as Verilog"])));
}

const devSheetItems = ofArray(["Lock", "Unlock", "Lock Subtree", "Unlock Subtree"]);

const componentItems = ofArray(["Rotate Clockwise", "Rotate AntiClockwise", "Flip Vertical", "Flip Horizontal", "Delete", "Copy", "Properties"]);

const customComponentItems = ofArray(["Go to sheet", "Properties", "Move ports", "Resize symbol"]);

function libraryInstanceItems(openItem) {
    return ofArray([openItem, "Properties", "Move ports", "Resize symbol"]);
}

const canvasItems = ofArray(["Zoom-in and centre", "Zoom-out", "Fit to window", "Paste", "Reroute all wires", "Properties"]);

export const contextMenus = ofArray([["SheetMenuBreadcrumbDev", append(sheetItems(true), devSheetItems)], ["SheetMenuBreadcrumbDevNoTop", append(sheetItems(false), devSheetItems)], ["SheetMenuBreadcrumb", sheetItems(true)], ["SheetMenuBreadcrumbNoTop", sheetItems(false)], ["CatalogueLibrary", singleton("Export library")], ["ProjectPath", ofArray(["Copy path", "Open directory"])], ["CustomComponent", customComponentItems], ["CustomComponentWaveSim", append(customComponentItems, singleton(addWavesItem))], ["LibraryInstance", libraryInstanceItems(viewLibraryItem)], ["LibraryInstanceWaveSim", append(libraryInstanceItems(viewLibraryItem), singleton(addWavesItem))], ["LibraryInstanceOpen", libraryInstanceItems(hideLibraryItem)], ["LibraryInstanceOpenWaveSim", append(libraryInstanceItems(hideLibraryItem), singleton(addWavesItem))], ["ScalingBox", ofArray(["Rotate Clockwise", "Rotate AntiClockwise", "Flip Vertical", "Flip Horizontal", "Delete Box", "Copy Box", "Move Box (Drag any component)"])], ["Component", componentItems], ["ComponentWaveSim", append(componentItems, singleton(addWavesItem))], ["Canvas", canvasItems], ["Wire", singleton("Unfix Wire")], ["WireWaveSim", ofArray(["Unfix Wire", addWireWaveItem])], ["ComponentReadOnly", singleton("Properties")], ["LibraryInstanceReadOnly", ofArray([viewLibraryItem, "Properties"])], ["LibraryInstanceOpenReadOnly", ofArray([hideLibraryItem, "Properties"])], ["CanvasReadOnly", ofArray(["Zoom-in and centre", "Zoom-out", "Fit to window", "Properties"])], ["SheetMenuBreadcrumbLibrary", singleton(hideLibraryItem)], ["WaveSimHelp", ofArray(["Waveform and RAM selection", "Viewing Waveforms", "Miscellaneous"])], ["", empty()]]);

const menuMap = ofList(contextMenus, {
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
});

/**
 * The items of the named menu; empty where the name is not a menu.
 */
export function menuItemsFor(name) {
    let option_1;
    return defaultArg((option_1 = tryFind(name, menuMap), (option_1 != null) ? toArray(option_1) : undefined), []);
}

/**
 * Whether the name is one of the menus. Distinct from `menuItemsFor` returning empty, because
 * the no-menu entry "" is a real name whose menu is deliberately empty.
 */
export function isMenuName(name) {
    return containsKey(name, menuMap);
}

export const menuNames = toArray(map((tuple) => tuple[0], toList(menuMap)));

/**
 * The keys shown beside a right-click menu item, as Electron accelerators: (Windows/Linux, macOS).
 * 
 * SHOWN and never registered - see ContextMenuBuilder - so this decides what the menu says and
 * nothing at all about what a key does. The items used to spell their keys inside their own
 * labels, which put "Ctrl" in front of a macOS user whose key is Cmd, and put the keys on the left
 * where every other menu on the machine draws them on the right.
 * 
 * Written out rather than read from KeyTypes because this file is compiled into the main process,
 * which has none of the renderer. Issie.KeyBindings holds the two together: the test suite can see
 * both, and fails if a chord here is not the chord that fires.
 */
export function acceleratorOf(item) {
    switch (item) {
        case "Rotate Clockwise":
            return ["Ctrl+Right", "Command+Right"];
        case "Rotate AntiClockwise":
            return ["Ctrl+Left", "Command+Left"];
        case "Flip Vertical":
            return ["Ctrl+Up", "Command+Up"];
        case "Flip Horizontal":
            return ["Ctrl+Down", "Command+Down"];
        case "Delete":
        case "Delete Box":
            return ["Delete", "Backspace"];
        case "Copy":
        case "Copy Box":
            return ["Ctrl+C", "Command+C"];
        case "Paste":
            return ["Ctrl+V", "Command+V"];
        case "Zoom-in and centre":
            return ["Ctrl+Plus", "Command+Plus"];
        case "Zoom-out":
            return ["Ctrl+-", "Command+-"];
        case "Fit to window":
            return ["Ctrl+0", "Command+0"];
        default:
            return undefined;
    }
}

